module.exports = __webpack_public_path__ + "img/plant_5_mobile.72df8132.webp";